<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part">The House Inside the Horse</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p01.vue?373acbfc